import axios from "./axios.interceptors";

import {
  CreateFlightRequestTypes,
  ExportFlightSkyScanner,
  FilterFlightsQueryParams,
  FlightRequestBody,
  FlightSearchRequest,
  UpdateRoutePricesParams,
  GetFlightHistoryParams,
  PagedHistory,
  FlightImportResponse
} from "app/types/service-types/FlightTypes";


class FlightServices {

  searchFlights = async (params: FlightSearchRequest): Promise<any> => {
    try {
      const response = await axios.get('/api/flights/search', {params});
      console.log(response);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  public getAll = async (): Promise<FlightRequestBody[]> => {
    try {
      const response = await axios.get('/api/flights');
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  filterFlights = async (queryParams: FilterFlightsQueryParams): Promise<any> => {
    try {
      const response = await axios.get('/api/flights', {params: queryParams});
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  createFlight = async (body: CreateFlightRequestTypes): Promise<any> => {
    try {
      return await axios.post('/api/flights', body);
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  updateFlight = async (id: string, body: any): Promise<any> => {
    const response = await axios.put(`/api/flights/${id}`, body);
    return response;
  }

  deleteFlight = async (id: string): Promise<any> => {
    const response = await axios.delete(`/api/flights/${id}`);
    return response;
  }

  getFlightById = async (id: string): Promise<any> => {
    try {
      const response = await axios.get(`/api/flights/${id}`);
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  getPassengersFlightById = async (id: string): Promise<any> => {
    try {
      const response = await axios.get(`/api/flights/${id}/travelers`);
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  getReservationsFlightById = async (id: string): Promise<any> => {
    try {
      const response = await axios.get(`/api/flights/${id}/reservations`);
      return response.data;
    } catch (err) {
      throw err;
    }
  }

  exportFlight = async (body: ExportFlightSkyScanner): Promise<any> => {
    try {
      const response = await axios.post('/api/flights/export', body);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
  
  fetchFlightHistory = async (id: string): Promise<GetFlightHistoryParams[]> => {
    try {
      const response = await axios.get(`/api/flights/${id}/history`);
      const data = response.data;

      if (Array.isArray(data)) return data as GetFlightHistoryParams[];
      if (data?.content && Array.isArray(data.content)) return data.content as GetFlightHistoryParams[];

      return data ? [data as GetFlightHistoryParams] : [];
    } catch (err) {
      throw err;
    }
  };
  // service
    fetchFlightHistoryPaged = async (
      id: string,
      page = 0,
      size = 20,
      sort: string[] = ["changedAt,desc"]
    ): Promise<PagedHistory> => {
      const { data } = await axios.get(`/api/flights/${id}/history`, {
        params: { page, size, sort }
      });
      return data as PagedHistory;
    };

  importFromCsv = async (file: File): Promise<FlightImportResponse> => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await axios.post('/api/flights/import-csv', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  overridePriceByClass = async (flightId: string, seatClassName: string, priceOverride: number): Promise<any> => {
    try {
      const response = await axios.post(
        `/api/flights/${flightId}/seat-pricing/override-by-class?seatClassName=${encodeURIComponent(seatClassName)}&priceOverride=${priceOverride}`
      );
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  overridePriceBySeat = async (flightId: string, seatLabel: string, priceOverride: number): Promise<any> => {
    try {
      const response = await axios.put(
        `/api/flights/${flightId}/seat-pricing/override-by-seat?seatLabel=${encodeURIComponent(seatLabel)}&priceOverride=${priceOverride}`
      );
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  getFlightSeats = async (flightId: string): Promise<any> => {
    try {
      const response = await axios.get(`/api/flights/${flightId}/flight-seats`);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  getFlightSeatById = async (flightId: string, seatId: string): Promise<any> => {
    try {
      const response = await axios.get(`/api/flights/${flightId}/flight-seats/${seatId}`);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  updateFlightSeat = async (
    flightId: string,
    seatId: string,
    body: { status?: string; priceOverride?: number | null }
  ): Promise<any> => {
    try {
      const response = await axios.put(`/api/flights/${flightId}/flight-seats/${seatId}`, body);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

}
  
export const updateRoutePrices = (params: UpdateRoutePricesParams) => {
  const qs = new URLSearchParams({
    ...(params.departureAirportCode ? { departureAirportCode: params.departureAirportCode } : {}),
    ...(params.arrivalAirportCode ? { arrivalAirportCode: params.arrivalAirportCode } : {}),
    fromDate: params.fromDate,
    toDate: params.toDate,
    priceAdjustment: String(params.priceAdjustment),
  }).toString();

  return axios.post(`api/flights/update-route-prices?${qs}`);
};

export default new FlightServices();
